import { t } from '@lingui/macro';
import { REGX_EMAIL, REGX_PHONE_NUMBER } from '@core/constants';

export function getInstallerRules() {
    return {
        enterpriseName: [
            { required: true, message: t`Cannot be empty` },
            { max: 200, message: t`Cannot be greater than 200 characters` },
        ],
        providerType: [{ required: true, message: t`Cannot be empty` }],
        country: [
            { required: true, message: t`Cannot be empty` },
            { max: 64, message: t`Cannot be greater than 64 characters` },
        ],
        province: [{ max: 64, message: t`Cannot be greater than 64 characters` }],
        city: [
            { required: true, message: t`Cannot be empty` },
            { max: 64, message: t`Cannot be greater than 64 characters` },
        ],
        address: [
            { required: true, message: t`Cannot be empty` },
            { max: 255, message: t`Cannot be greater than 255 characters` },
        ],
        postCode: [
            { required: true, message: t`Cannot be empty` },
            { max: 10, message: t`Cannot be greater than 10 characters` },
        ],
        chargeFirstName: [
            { required: true, message: t`Cannot be empty` },
            { max: 255, message: t`Cannot be greater than 255 characters` },
        ],
        chargeLastName: [
            { required: true, message: t`Cannot be empty` },
            { max: 255, message: t`Cannot be greater than 255 characters` },
        ],
        chargeEmail: [
            { required: true, message: t`Cannot be empty` },
            { max: 64, message: t`Cannot be greater than 64 characters` },
            {
                pattern: REGX_EMAIL,
                message: t`Incorrect email address format`,
            },
        ],
        chargeAreaCode: [{ required: true, message: t`Cannot be empty` }],
        chargePhoneNumber: [
            { required: true, message: t`Cannot be empty` },
            { max: 64, message: t`Cannot be greater than 64 characters` },
            {
                pattern: REGX_PHONE_NUMBER,
                message: t`Wrong cell phone number`,
            },
        ],
    };
}

export const AREA_CODE = [
    { label: '+86', value: '+86' },
    { label: '+49', value: '+49' },
    { label: '+1', value: '+1' },
    { label: '+44', value: '+44' },
    { label: '+81', value: '+81' },
    { label: '+39', value: '+39' },
    { label: '+30', value: '+30' },
    { label: '+31', value: '+31' },
    { label: '+32', value: '+32' },
    { label: '+33', value: '+33' },
    { label: '+34', value: '+34' },
    { label: '+350', value: '+350' },
    { label: '+351', value: '+351' },
    { label: '+352', value: '+352' },
    { label: '+353', value: '+353' },
    { label: '+354', value: '+354' },
    { label: '+355', value: '+355' },
    { label: '+356', value: '+356' },
    { label: '+357', value: '+357' },
    { label: '+358', value: '+358' },
    { label: '+359', value: '+359' },
    { label: '+36', value: '+36' },
    { label: '+370', value: '+370' },
    { label: '+371', value: '+371' },
    { label: '+372', value: '+372' },
    { label: '+373', value: '+373' },
    { label: '+374', value: '+374' },
    { label: '+375', value: '+375' },
    { label: '+376', value: '+376' },
    { label: '+377', value: '+377' },
    { label: '+378', value: '+378' },
    { label: '+380', value: '+380' },
    { label: '+381', value: '+381' },
    { label: '+382', value: '+382' },
    { label: '+385', value: '+385' },
    { label: '+386', value: '+386' },
    { label: '+387', value: '+387' },
    { label: '+388', value: '+388' },
    { label: '+389', value: '+389' },
    { label: '+40', value: '+40' },
    { label: '+41', value: '+41' },
    { label: '+420', value: '+420' },
    { label: '+421', value: '+421' },
    { label: '+423', value: '+423' },
    { label: '+43', value: '+43' },
    { label: '+45', value: '+45' },
    { label: '+46', value: '+46' },
    { label: '+47', value: '+47' },
    { label: '+48', value: '+48' },
    { label: '+7', value: '+7' },
    { label: '+997', value: '+997' },
].sort((a, b) => {
    return +a.label.slice(1) - +b.label.slice(1);
});

export const PROVIDER_TYPE = [
    {
        label: t`Installer`,
        value: 0,
    },
    {
        label: t`web_ef_register_agent`, // 代理商
        value: 1,
    },
    {
        label: t`Sunnova`, // 代理商
        value: 2,
    },
];
